import { Component, HostListener, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { SynchronizeInventoryMovementService } from 'src/app/services/utilities/synchronize-inventory-movement.service';

@Component({
  selector: 'app-synchronize-inventory-movement',
  templateUrl: './synchronize-inventory-movement.component.html',
  styleUrls: ['./synchronize-inventory-movement.component.scss'],
  standalone: false,
})
export class SynchronizeInventoryMovementComponent implements OnInit {
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly headerService = inject(HeaderService);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly synchronizationService = inject(
    SynchronizeInventoryMovementService,
  );

  alerts: PreInvoicingAlertModel[] = [];
  errorMessage: string = '';
  isSynchronizing: boolean = false;
  hasSynchronized: boolean = false;
  isOpened: string | undefined = undefined;
  nameWindow: string = 'Sincronizar Siesa';
  projectName = ProjectName.projectName;

  url: string = 'siesa-synchronize';

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }


  cancel() {}

  async syncUp() {
    if (this.isSynchronizing || this.hasSynchronized) return;

    const accepted = await this.confirmDialogService.confirm(
      '¿Realmente desea correr el proceso de sincronización con Siesa?',
    );

    if (accepted) {
      this.isSynchronizing = true;
      this.errorMessage = '';
      try {
        this.alerts = await firstValueFrom(
          this.synchronizationService.synchronizeAsync(),
        );
        this.hasSynchronized = true;
      } catch (error) {
        console.error(
          'Error al sincronizar los movimientos Siesa.',
          error,
        );
        this.errorMessage =
          'No fue posible completar la sincronización de los movimientos con Siesa.';
      } finally {
        this.isSynchronizing = false;
      }
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(
      AuthenticationContants.keyWindowsOpenedLocalStorage,
    );
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find((x) => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(
        AuthenticationContants.keyWindowsOpenedLocalStorage,
        JSON.stringify(windowsOpened),
      );
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`,
        );
      }
    } else {
      localStorage.clear();
    }
    // await this.getGeneralParameter();
    // await this.getAllLists();
    // await this.getUserPermissions();
  }
}
